import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    inboxDateRangeFilter: {
        // Should always be `null`, otherwise it fires additional request with this initial values right before the
        // necessary request with values gotten from local storage.
        dateFrom: null,
        dateTo: null,
    },
    inboxArticleSearchTerm: '',
    isReceiptedActive: false,
    receiptedInvoiceCount: undefined,
    notReceiptedInvoiceCount: undefined,
    verificationItemCount: undefined,
    ownerLocation: 'invoice',
    placeStockReceiptItemDialog: {
        open: false,
        data: undefined,
    },
};
const slice = createSlice({
    name: 'stockReceipt',
    initialState,
    reducers: {
        setInboxDateRangeFilter: (state, action) => {
            state.inboxDateRangeFilter = action.payload;
        },
        setIsReceiptedActive: (state, action) => {
            state.isReceiptedActive = action.payload;
        },
        setReceiptedInvoiceCount: (state, action) => {
            state.receiptedInvoiceCount = action.payload;
        },
        setNotReceiptedInvoiceCount: (state, action) => {
            state.notReceiptedInvoiceCount = action.payload;
        },
        updateInvoicesTabCounters: (state, action) => {
            if (state.notReceiptedInvoiceCount === undefined || state.receiptedInvoiceCount === undefined)
                return;
            if (action.payload === 'movedToReceipted') {
                state.notReceiptedInvoiceCount = state.notReceiptedInvoiceCount - 1;
                state.receiptedInvoiceCount = state.receiptedInvoiceCount + 1;
            }
            else {
                state.notReceiptedInvoiceCount = state.notReceiptedInvoiceCount + 1;
                state.receiptedInvoiceCount = state.receiptedInvoiceCount - 1;
            }
        },
        setVerificationItemCount: (state, action) => {
            state.verificationItemCount = action.payload;
        },
        setInboxArticleSearchTerm: (state, action) => {
            state.inboxArticleSearchTerm = action.payload;
        },
        setOwnerLocation: (state, action) => {
            state.ownerLocation = action.payload;
        },
        openPlaceReceiptItemDialog: (state, action) => {
            state.placeStockReceiptItemDialog = {
                ...state.placeStockReceiptItemDialog,
                open: true,
                data: action.payload,
            };
        },
        closePlaceReceiptItemDialog: (state) => {
            state.placeStockReceiptItemDialog = initialState.placeStockReceiptItemDialog;
        },
    },
});
export const { actions: stockReceiptActions, reducer: stockReceiptStateReducer } = slice;
